import PropTypes from 'prop-types';
import {
  Button,
  TextField,
  InputAdornment,
  SvgIcon,
  Grid,
  Box,
  Card,
  CardContent,
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDebounce } from 'use-debounce/lib';
import { useEffect } from 'react';

const Container = ({ children }) => {
  return (
    <Box mt={3}>
      <Card>
        <CardContent>{children}</CardContent>
      </Card>
    </Box>
  );
};

const ToolbarFilters = ({ 
    resetPage, 
    name, 
    setName,
    activePrinciple,
    setActivePrinciple 
  }) => {
  const { t } = useTranslation('drugs');
  const [nameValue, setNameValue] = useState(name);
  const [nameDebouncedValue] = useDebounce(nameValue, 500);
  const [activePrincipleValue, setActivePrincipleValue] = useState(activePrinciple);
  const [activePrincipleDebouncedValue] = useDebounce(activePrincipleValue, 500);

  const handleReset = () => {
    resetPage();
    setName('');
    setNameValue('');
    setActivePrinciple('');
    setActivePrincipleValue('');
  };

  useEffect(() => {
    setName(nameDebouncedValue);
    setActivePrinciple(activePrincipleDebouncedValue);
    resetPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameDebouncedValue, activePrincipleDebouncedValue, setName, setActivePrinciple]);

  return (
    <Container>
      <Grid container alignItems="center" spacing={3}>
        <Grid item xs={12} sm={6} md={5}>
          <TextField
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="primary">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              ),
            }}
            placeholder={t('labels.search_drugs_by_name')}
            value={nameValue}
            onBlur={(e) => setName(e.target.value)}
            onChange={(e) => {
              setNameValue(e.target.value);
            }}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={5}>
          <TextField
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="primary">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              ),
            }}
            placeholder={t('labels.search_drugs_by_active_principle')}
            value={activePrincipleValue}
            onBlur={(e) => setActivePrinciple(e.target.value)}
            onChange={(e) => {
              setActivePrincipleValue(e.target.value);
            }}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={4} md={3} xl={2}>
          <Button fullWidth color="primary" variant="contained" onClick={handleReset}>
            {t('buttons.drugs_list_clear_filters')}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

ToolbarFilters.propTypes = {
  setPage: PropTypes.func,
  name: PropTypes.string,
  setName: PropTypes.func,
  activePrinciple: PropTypes.string,
  setActivePrinciple: PropTypes.func,
};

export default ToolbarFilters;
